<template>
  <transition name="storybook-loading" @enter="handleEnter">
    <div class="pa-storybook-loading" v-if="isOpen">
      <div class="loading-container">
        <div class="loading-message" :class="loadingMessageClass">
          <div class="loading-icon" ref="storyBookLoadingIcon">
            <KiimoIcon />
          </div>
          <div class="loading-text">
            <p>読み込み中</p>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import KiimoIcon from '@/components/FrontParts/LoginModal/LoginBox/Images/login-icon.svg?inlineF'

export default {
  props : {
    isOpen : {
      default: false
    }
  },
  components : {
    KiimoIcon
  },

  data(){
    return {
      isOpenLoading : false,
      shouldAnimate : false,

      loadingMessageClass : {
        'loading-message-animate' : false
      }
    };
  },

  watch : {
    isOpen : {
      handler(value){
        this.isOpenLoading = value;
      },
      immediate: true
    },

    shouldAnimate : {
      handler(value){
        this.loadingMessageClass['loading-message-animate'] = value;
      },
      immediate: true
    },

    isOpenLoading : {
      handler(value){
        if(value === false) return;
        
        this.initializeAnimation();
      },
      immediate: true
    },
  },

  methods : {
    initializeAnimation(){
      this.$nextTick(() => {
        if(typeof this.$refs.storyBookLoadingIcon === 'undefined') return;

        this.shouldAnimate = true;

        this.$refs.storyBookLoadingIcon.addEventListener('animationend', this.handleAnimationEnd);
      });
    },

    handleAnimationEnd(){
      this.shouldAnimate = false;

      setTimeout(() => {
        this.shouldAnimate = true;
      }, 500);
    },
    
    handleEnter(){
    }
  },

  beforeDestroy(){
    if(typeof this.$refs.storyBookLoadingIcon !== 'undefined'){
      this.$refs.storyBookLoadingIcon.removeEventListener('animationend', this.handleAnimationEnd);
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/mixins.scss";

@keyframes storybookTextFade
{
  0%   {
    transform: scale(.99);
    backdrop-filter: blur(3px);
    opacity:0;
  }
  100% {
    transform: scale(1);
    backdrop-filter: blur(0px);
    opacity:1;
  }
}

@keyframes fastFadeOut
{
  0%   {
    opacity:1;
  }
  100% {
    opacity:0;
  }
}

@keyframes circleLoading
{
  0% {
    transform: rotate(30deg) scale(.50);
    opacity:0;
  }
  35% {
    transform: rotate(210deg);
    opacity:.5;
  }
  75% {
    transform: rotate(0deg);
    opacity:.9;
  }
  100% {
    transform: rotate(-30deg) scale(.50);
    opacity:0;
  }
}

@keyframes circleLoadingText
{
  0% {
    color:#d7c6a8;
    opacity:0;
  }
  35% {
    color:#937a4a;
    opacity:1;
  }
  75% {
    color:#5e481d;
  }
  78% {
    color:#937a4a;
    opacity:1;
  }
  100% {
    color:#d7c6a8;
    opacity:0;
  }
}

.storybook-loading{
  &-enter-active{
    opacity: 1;
    animation: storybookTextFade 2s;
  }

  &-leave-active{
    animation: fastFadeOut 1s;
  }

  &-enter, &-leave-to{
    opacity: 0;
  }
}

.pa-storybook-loading{
  background: radial-gradient($golden-box-background 50%, $golden-box-background-darker 80%, $golden-box-background-x-darker);
  border-radius: 8px;
  z-index:600;
  position: absolute;
  top:0;
  left:0;
  width:100%;
  height:100%;

  .loading-container{
    width:100%;
    height: 100%;
    align-items: center;
    display: flex;
    flex-grow:1;
    flex-shrink: 1;
    text-align:center;

    .loading-message{
      opacity:.9;
      margin-top:-10%;
      width:100%;
      user-select: none;

      &-animate{
        .loading-icon{
          animation: circleLoading 5s;
        }

        .loading-text{
          animation: circleLoadingText 5s;
        }
      }

      .loading-icon{
        width:100%;
        display: block;
        opacity: 0;
        
        svg{
          width:25%;
          max-width:100px;

          circle{
            fill: rgb(221, 206, 179);
            stroke: rgb(196, 135, 26);
          }

          rect, path{
            fill: #c4871a;
          }
        }
      }

      .loading-text{
        margin-top:.8rem;
        font-size:1.3rem;
        opacity: 0;

        @media screen and (min-width: $desktop) {
          margin-top:12px;
        }
      }
    }
  }
}
</style>